import { styled, Menu, menuClasses, MenuItem } from '@mui/material';

import AccessFeature from '~components/AccessFeature';

export const AssistantGenerateRoutesActionMenuContainer = styled(Menu)({
  [`& .${menuClasses.paper}`]: {
    border: '1px solid #d3d4d5',
  },
});

export const AssistantGenerateRoutesActionMenuItemContainer = styled(MenuItem)({
  whiteSpace: 'pre-wrap',
});

export const AssistantGenerateRoutesActionMenuItemAccessFeatureContainer =
  styled(AccessFeature.MenuItem)({ whiteSpace: 'pre-wrap' });
